<template>
    <vue-simplemde
        v-if="editorOnly"
        v-model="description"
        :sanitize="true"
        :configs="markdownTools"
    ></vue-simplemde>

    <div v-else class="form-block">
        <h3>Description</h3>
        <div class="fields-container">
            <vue-simplemde
                v-model="description"
                :sanitize="true"
                :configs="markdownTools"
            ></vue-simplemde>
        </div>
    </div>
</template>
<script>
export default {
    name: "Description",
    props: ["textBackup", "value", "editorOnly"],
    data: () => ({
        markdownTools: {
            promptURLs: true,
            spellChecker: false,
            toolbar: [
                "bold",
                "italic",
                "strikethrough",
                "heading",
                "|",
                "quote",
                "unordered-list",
                "ordered-list",
                "table",
                "|",
                "link",
                "image",
                "code",
                "horizontal-rule",
                "|",
                "preview",
                "side-by-side",
                "fullscreen",
                "guide",
            ],
            status: false,
        },
    }),
    computed: {
        description: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            },
        },
    },
};
</script>
<style lang="scss">
.op-image.popup-dropdown .dropdown-item:last-of-type {
    display: none;
}

.vue-simplemde {
    max-height: 70vh;
    .CodeMirror {
        height: calc(100% - 49px);
    }
    .CodeMirror-fullscreen,
    .editor-preview-side {
        margin-top: 118px;
    }
    .no-mobile {
        display: inline-block !important;
    }
    .fullscreen {
        top: 118px;

        z-index: 999999999 !important;
        &::before,
        &::after {
            top: 118px;
        }
    }
    .editor-toolbar.fullscreen {
        top: 118px;
    }
}
.v-note-wrapper {
    min-width: 0 !important;
    z-index: 1000 !important;
    height: 450px;
}
</style>
